export enum OrganizationRoleEnum {
  SuperAdmin = 'super-admin',
  LicenseAdmin = 'license-admin',
  BillingAdmin = 'billing-admin',
  ProjectAdmin = 'project-admin',
  Member = 'member',
}
